import {FC, PropsWithChildren, createElement} from "react";
import {
  PlaceholderProps,
  DefaultPlaceholder,
  WhenDefined
} from "../custom-elements";

export interface WebComponentProps {
  element: string;
  attributes?: Record<string, any>;
  placeholder?: FC<PlaceholderProps>;
}

/**
 * The {@link WebComponent} enables injection of a WebComponent at runtime.
 * The primary use-case for this component is the injection of a WebComponent
 * at runtime driven by configuration where the following can be externalized:
 *
 * <ul>
 *     <li>The element/tag name exported by the real WebComponent</li>
 *     <li>The attributes used to configure the real WebComponent</li>
 *     <li>The source location(s) of the real WebComponent</li>
 * </ul>
 *
 *
 * @param element
 * @param attributes
 * @param placeholder
 * @param children
 * @constructor
 */
export const WebComponent: FC<PropsWithChildren<WebComponentProps>> = ({
  element,
  attributes = {},
  placeholder = DefaultPlaceholder,
  children
}) => {
  return (
    <WhenDefined element={element} placeholder={placeholder}>
      {createElement(element, attributes, children)}
    </WhenDefined>
  );
};
